var _defs, _circle, _circle2, _circle3, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvenient(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 126 126",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:#cb8b65;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 62.69,
    y1: 127.24,
    x2: 62.69,
    y2: 2.05,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 128)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ed9765"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 62.69,
    cy: 63.36,
    r: 62.59
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 62.69,
    cy: 63.36,
    r: 54.71
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 62.69,
    cy: 63.36,
    r: 42.87
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.1,83.62c-2.52-.17-5-.36-7.54-.51a17.81,17.81,0,0,0-8.43,1.08.38.38,0,0,1-.49-.12Q43.32,79.74,39,75.42c-.16-.16-.26-.26-.05-.5a36.11,36.11,0,0,1,5.81-5.65,9.86,9.86,0,0,1,4.32-1.94,9.84,9.84,0,0,1,5,.79c2.33.88,4.59,1.94,7,2.6a28.62,28.62,0,0,0,6.89,1,3.93,3.93,0,0,1,1.36.15,2,2,0,0,1,1.39,1.92,1.85,1.85,0,0,1-1.36,1.8,10.34,10.34,0,0,1-4,.4,18,18,0,0,1-6.28-1.27,1,1,0,0,0-1.28.47,1,1,0,0,0,.52,1.35,13,13,0,0,0,3.12,1c4.89,1.19,9.42.16,13.78-2.13,3.19-1.69,6.22-3.66,9.32-5.49a3.58,3.58,0,0,1,2.13-.58,1.81,1.81,0,0,1,1.67,2.4,3.51,3.51,0,0,1-1.23,1.7,35.81,35.81,0,0,1-3.85,2.74c-2.87,1.85-5.83,3.55-8.85,5.14A19.43,19.43,0,0,1,64.1,83.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M61.73,41c0-2.24-1.15-3-2.73-3.12a16.47,16.47,0,0,1,5.28-2.68,17.16,17.16,0,1,1-12,19,16.69,16.69,0,0,1,.4-7,.53.53,0,0,0-.27-.73c-.7-.4-1.37-.86-2.05-1.29a.89.89,0,0,1,.08-1.68l8.26-3.78c.76-.35,1.34,0,1.36.81q.06,4.62.07,9.23a.84.84,0,0,1-1.36.75c-.74-.44-1.46-.91-2.19-1.38A12.76,12.76,0,0,0,62.51,62.7,13,13,0,1,0,61.73,41Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.94,86.93a2,2,0,0,1-.59,1.38c-.82.82-1.64,1.62-2.44,2.45-.22.24-.33.17-.52,0q-5.58-5.59-11.18-11.17c-.24-.24-.19-.36,0-.57.8-.77,1.57-1.58,2.37-2.36a1.87,1.87,0,0,1,2.81,0c3,2.95,5.93,5.92,8.89,8.88A2.07,2.07,0,0,1,46.94,86.93Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.53,57.66A1.64,1.64,0,0,1,66,56.85c-1-1.78-2.09-3.57-3.1-5.38a1.61,1.61,0,1,1,2.79-1.6c.64,1.05,1.25,2.11,1.84,3.19.2.36.32.35.6.07,2.3-2.32,4.62-4.62,6.92-6.94a1.72,1.72,0,0,1,1.76-.59,1.61,1.61,0,0,1,.83,2.58,3.34,3.34,0,0,1-.32.33L68.8,57A1.74,1.74,0,0,1,67.53,57.66Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvenient);
export default __webpack_public_path__ + "static/media/Convenient.6b8edc1e16914baeba6e8bd5c76b42ca.svg";
export { ForwardRef as ReactComponent };